import type {
  ProjectProfitSummaryQuery,
  ProjectProfitTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";
import { ProjectReportStore } from "../../common/store";
import { ProjectProfitModel } from "../models";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "projectProfit";
  reportStore: ProjectReportStore;
  @observable projects: ProjectProfitModel[] = [];
  @observable
  summary?: ProjectProfitSummaryQuery["projectRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new ProjectReportStore(this.key);
  }

  @action setTableData(query: ProjectProfitTableDataQuery) {
    this.projects = (query.projectRevenue.projects ?? []).map(
      (i) => new ProjectProfitModel(i),
    );
    this.reportStore.setExpenseBudgetCategories(
      query.expenseBudgetCategories ?? [],
    );

    if (query.projectRevenue.projects) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.projectRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: ProjectProfitSummaryQuery) {
    this.summary = query.projectRevenueSummary;
  }
}
